import {
  FETCH_ABSENT_LAST5_REQUEST,
  FETCH_ABSENT_LAST5_SUCCESS,
  FETCH_ABSENT_LAST5_FAILURE,
} from "../constants/AbsentLast5Constants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const AbsentLast5Reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ABSENT_LAST5_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ABSENT_LAST5_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_ABSENT_LAST5_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AbsentLast5Reducer;